import { MapPin, Users, Star } from 'lucide-react';
import SEO from '../components/SEO';
import { getAppUrl } from '../config/api';

const About = () => {
    return (
        <div style={{ paddingTop: '100px', paddingBottom: '4rem' }}>
            <SEO
                title="About Us - Hashtag PG & Flats | Premium Accommodations"
                description="Learn about Hashtag PG & Flats. We provide premium PG accommodations and rental properties in Pune with modern amenities and excellent service."
                keywords="about Hashtag PG, rental company Pune, accommodation provider"
                url={getAppUrl('about')}
            />
            <div className="container">
                <div className="section-title-wrapper" style={{ textAlign: 'center', marginBottom: '4rem' }}>
                    <span className="section-subtitle">Our Story</span>
                    <h1 className="section-title">About Hashtag PG</h1>
                </div>

                <div className="about-hero-container" style={{ display: 'flex', flexDirection: 'column', gap: '4rem', alignItems: 'center' }}>
                    <div>
                        <p style={{ fontSize: '1.125rem', lineHeight: '1.8', color: 'var(--text-light)', marginBottom: '1.5rem' }}>
                            Welcome to Hashtag PG, your trusted partner in finding the perfect accommodation in Pune. We understand that finding the right place to live is more than just four walls and a roof—it's about finding a space where you feel comfortable, safe, and at home.
                        </p>
                        <p style={{ fontSize: '1.125rem', lineHeight: '1.8', color: 'var(--text-light)' }}>
                            Our mission is to provide premium PG accommodations and rental flats that combine modern amenities with homely comfort. Each property in our collection is carefully selected  and maintained to ensure the highest standards of living.
                        </p>
                    </div>

                    <div className="about-stats-container" style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '2rem', textAlign: 'center', justifyContent: 'center' }}>
                        <div>
                            <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: 'var(--primary-color)', marginBottom: '0.5rem' }}>
                                <MapPin size={48} style={{ margin: '0 auto 1rem' }} />
                                50+
                            </div>
                            <div style={{ color: 'var(--text-light)' }}>Properties</div>
                        </div>
                        <div>
                            <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: 'var(--primary-color)', marginBottom: '0.5rem' }}>
                                <Users size={48} style={{ margin: '0 auto 1rem' }} />
                                1000+
                            </div>
                            <div style={{ color: 'var(--text-light)' }}>Happy Residents</div>
                        </div>
                        <div>
                            <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: 'var(--primary-color)', marginBottom: '0.5rem' }}>
                                <Star size={48} style={{ margin: '0 auto 1rem' }} />
                                4.8
                            </div>
                            <div style={{ color: 'var(--text-light)' }}>Average Rating</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
